import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetResultsSection, WorksheetRootComponent } from 'Components/Worksheets/Core';
import { PageSection } from '../../../../Layout';
import { AsResultsSection } from '../Sections';
import AsFieldResultsSection from '../Sections/FieldResults/FieldResultsSection';

let FieldWorksheet: WorksheetRootComponent = ({ createWorksheetSelector }) => {
  return (
    <>
      <PageSection heading="Field Results">
        <NamePrefixModifier appendNamePrefix="FieldResults">
          <AsFieldResultsSection />
        </NamePrefixModifier>
      </PageSection>
      <WorksheetResultsSection heading="Results">
        <AsResultsSection />
      </WorksheetResultsSection>
    </>
  );
};

const AsRelativeCompactionFieldWorksheet = withInjectedProps(FieldWorksheet);

export { AsRelativeCompactionFieldWorksheet };
export default AsRelativeCompactionFieldWorksheet;
